import React from "react";
import { Route } from "react-router-dom";
import { Button, Form, Grid, Message, Segment } from "semantic-ui-react";

const BookingForm = () => {

  
  return (
    <Grid.Column style={{ maxWidth: 450, padding: "1rem" }}>
      <Form size="large">
        <Segment stacked>
          <Form.Input
            fluid
            icon="user"
            iconPosition="left"
            placeholder="Name"
          />
          <Form.Input
            fluid
            icon="mail"
            iconPosition="left"
            placeholder="E-mail address"
          />
          <Form.Input
            fluid
            icon="phone"
            iconPosition="left"
            placeholder="Phone Number"
          />
          <Route
            render={({ history }) => (
              <Button
                color="orange"
                fluid
                size="large"
                onClick={() => {
                  console.log("validate form,check availablity again,loading!");
                  history.push("/confirm");
                }}
              >
                Confirm
              </Button>
            )}
          />
        </Segment>
      </Form>
      <Message>
        Having Troubles completing the Form? <a href="#"> </a>
      </Message>
    </Grid.Column>
  );
};

export default BookingForm;
